import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from  '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AppSettings} from '../../app.constant';
import {Batch} from '../interface/batch';
import { headersToString } from 'selenium-webdriver/http';

@Injectable({
  providedIn: 'root'
})
export class BatchService {

  httpOptions:any;
  headers:any;

  private _refreshNeeded$ = new Subject<void>();

  get refreshNeeded$() {
    return this._refreshNeeded$;
  }

  constructor(private http:HttpClient) 
    {
      this.httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': 'my-auth-token'
        })
      };
    }

    getEnrollment(url,param) {
      return this.http.post<Batch>(url,param,this.httpOptions)
     // return this.http.post<Batch>(url,param,this.httpOptions)
      // let params = new HttpParams().set("PK_BatchID",param);
      // let headers= new HttpHeaders(({
      //   'Content-Type':  'application/json',
      //   'Authorization': 'my-auth-token'
      // }));
     
      // return this.http.get(url,{headers:headers,params:params})
    }

    getAllBatch(url){
      return this.http.get(url,this.httpOptions)
    }

    getBatchByID(url,param){
      return this.http.post<Batch>(url,param,this.httpOptions)
    }

    GetBatchByProgramID(url,param){
      return this.http.post<Batch>(url,param,this.httpOptions)
    }

    postBatch(url,param){
      return this.http.post<Batch>(url,param,this.httpOptions)
      .pipe(
        tap(() =>  {
          this._refreshNeeded$.next();
        })
      );
    }

    updateBatch(url,param){
      return this.http.put<Batch>(url,param,this.httpOptions)
      .pipe(
        tap(() =>  {
          this._refreshNeeded$.next();
        })
      );
    }
     
    deleteBatchByID(url,param){
      return this.http.put<Batch>(url,param,this.httpOptions)
      .pipe(
        tap(() =>  {
          this._refreshNeeded$.next();
        })
      );
    }
}
